module.exports = __webpack_public_path__ + "img/arrow-right-from-line.1d93faa0.svg";